module.exports = __webpack_public_path__ + "static/media/dice-1.41a05242.png";